import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LightboxModule } from 'ngx-lightbox';

import { LotMiniGalleryComponent } from './lot-mini-gallery.component';

@NgModule({
  declarations: [LotMiniGalleryComponent],
  imports: [CommonModule, LightboxModule],
  exports: [LotMiniGalleryComponent],
})
export class LotMiniGalleryModule {}
